export default __webpack_public_path__ + "static/usa_texas_cash_five-65fdd78df3f854582dd7e00959c0b2e1.png";